import React, { FC } from 'react';
import { SpinnerContainerStyled, SpinnerItemStyled } from './styled';
import { StatsSpinnerProps, StatsSpinnerSize } from './types';

export const StatsSpinner: FC<StatsSpinnerProps> = ({ color, size = StatsSpinnerSize.SMALL }) => {
  return (
    <SpinnerContainerStyled color={color} size={size}>
      <SpinnerItemStyled animationDelay="-0.32s"></SpinnerItemStyled>
      <SpinnerItemStyled animationDelay="-0.16s"></SpinnerItemStyled>
      <SpinnerItemStyled></SpinnerItemStyled>
    </SpinnerContainerStyled>
  );
};
